




































































































import { Component, Vue } from 'vue-property-decorator';

import DeleteAccountSummaryViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/user-profile-delete-account/delete-account-summary-view-model';

@Component({ name: 'DeleteAccountSummary' })
export default class DeleteAccountSummary extends Vue {
  delete_account_summary_view_model = Vue.observable(
    new DeleteAccountSummaryViewModel(this),
  );

  created() {
    this.delete_account_summary_view_model.initialize();
  }
}
